import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { Box, Container, Card, Section, Grid, Button, useWindowSize } from '@miro-site/core';
import { ButtonAdapter, Headline, LazyImageAdapter, Content } from '@miro-site/components_utils';
import { theme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LogoContainer = styled(Box).withConfig({
  displayName: "TestimonialsCarousel__LogoContainer",
  componentId: "sc-ojnn71-0"
})(["overflow:hidden;img{width:auto;max-width:100%;max-height:100%;}"]);
var Avatar = styled(Box).attrs({
  $styles: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    overflow: 'hidden'
  },
  $mr: theme.spaces.md
}).withConfig({
  displayName: "TestimonialsCarousel__Avatar",
  componentId: "sc-ojnn71-1"
})(["img{width:100%;height:100%;}"]);

var TestimonialCard = function TestimonialCard(_ref) {
  var logo = _ref.logo,
      body = _ref.body,
      author = _ref.author;
  return /*#__PURE__*/_jsxs(Card, {
    $hasBorder: false,
    $p: [25, 35],
    $styles: {
      borderRadius: theme.spaces.sm,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: [460, 440]
    },
    children: [logo && /*#__PURE__*/_jsx(LogoContainer, {
      $styles: {
        height: 60
      },
      children: /*#__PURE__*/_jsx(LazyImageAdapter, {
        assets: logo
      })
    }), /*#__PURE__*/_jsx(Content, {
      html: body,
      color: "grey",
      textProps: {
        $variant: ['p2', 'p1'],
        $mt: theme.spaces.lg,
        $mb: theme.spaces.xl
      }
    }), author && /*#__PURE__*/_jsxs(Box, {
      $styles: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 'auto'
      },
      children: [author.avatar && /*#__PURE__*/_jsx(Avatar, {
        children: /*#__PURE__*/_jsx(LazyImageAdapter, {
          assets: author.avatar
        })
      }), /*#__PURE__*/_jsxs(Box, {
        $styles: {
          maxWidth: '70%'
        },
        children: [/*#__PURE__*/_jsx(Content, {
          html: author.name,
          size: "tiny",
          color: "grey"
        }), /*#__PURE__*/_jsx(Content, {
          html: author.designation,
          size: "tiny",
          color: "grey"
        })]
      })]
    })]
  });
};

var CircularButtonWithIcon = styled(Button).attrs({
  $styles: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    fontSize: theme.typography.paragraphs.p1.fontSize
  },
  $mx: theme.spaces.lg / 2
}).withConfig({
  displayName: "TestimonialsCarousel__CircularButtonWithIcon",
  componentId: "sc-ojnn71-2"
})([""]);

var TestimonialsCarousel = function TestimonialsCarousel(_ref2) {
  var headline = _ref2.headline,
      cta = _ref2.cta,
      list = _ref2.list,
      sectionId = _ref2.sectionId;

  var _useState = useState(0),
      currentSlide = _useState[0],
      setCurrentSlide = _useState[1];

  var _useState2 = useState(3),
      itemsPerSlide = _useState2[0],
      setItemsPerSlide = _useState2[1]; // Default to 3 cards for desktop


  var firstItemIndex = itemsPerSlide * currentSlide;
  var maxSlides = Math.ceil(list.length / itemsPerSlide) - 1;

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  useEffect(function () {
    if (width && width <= theme.breakpoints.v2Mobile) {
      setItemsPerSlide(1);
    } else {
      setItemsPerSlide(3);
    }
  }, [width]);
  var nextSlide = useCallback(function () {
    setCurrentSlide(function (currentSlide) {
      return currentSlide >= maxSlides ? 0 : currentSlide + 1;
    });
  }, [currentSlide, maxSlides]);
  var previousSlide = useCallback(function () {
    setCurrentSlide(function (currentSlide) {
      return currentSlide <= 0 ? maxSlides : currentSlide - 1;
    });
  }, [currentSlide, maxSlides]);
  return /*#__PURE__*/_jsx(Section, {
    id: sectionId,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [(headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(Headline, _objectSpread({
        align: "center"
      }, headline)), cta && /*#__PURE__*/_jsx(Box, {
        $my: theme.spaces.lg,
        $styles: {
          textAlign: 'center'
        },
        children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread({
          type: "secondary-dark"
        }, cta))
      }), /*#__PURE__*/_jsx(Box, {
        $styles: {
          marginTop: [theme.spaces.xl]
        },
        children: /*#__PURE__*/_jsx(Grid, {
          columns: 3,
          align: "stretch",
          children: list.slice(firstItemIndex, firstItemIndex + itemsPerSlide).map(function (item, index) {
            return /*#__PURE__*/_jsx(TestimonialCard, _objectSpread({}, item), JSON.stringify(item));
          })
        })
      }), list.length > itemsPerSlide && /*#__PURE__*/_jsxs(Box, {
        $m: theme.spaces.lg,
        $styles: {
          textAlign: 'center'
        },
        children: [/*#__PURE__*/_jsx(CircularButtonWithIcon, {
          $buttonType: 'secondaryBlue',
          onClick: previousSlide,
          "aria-label": "previous testimonials",
          children: "\u2190 "
        }), /*#__PURE__*/_jsx(CircularButtonWithIcon, {
          $buttonType: 'secondaryBlue',
          onClick: nextSlide,
          "aria-label": "next testimonials",
          children: "\u2192"
        })]
      })]
    })
  });
};

export default TestimonialsCarousel;